import 'material-design-icons-iconfont/dist/material-design-icons.css'
import './scss/main.scss'

import { createApp } from 'vue'
import App from './App.vue'
import { createVuestic } from 'vuestic-ui'
import router from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import { $fetch } from './api/api.fetch'
import { kioskCall } from './utils/kiosk'

const tenantId = import.meta.env.TENANT_ID || import.meta.env.VITE_TENANT_ID || null
const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || ''

$fetch.setActiveTenantId(tenantId)
$fetch.setApiBaseUrl(apiBaseUrl)

kioskCall<any>('app.getConfig').then((x) => {
  $fetch.setActiveTenantId(x.tenantId)
  $fetch.setApiBaseUrl(x.apiBaseUrl)
})

const app = createApp(App)
app.use(router)
app.use(createVuestic({ config: vuesticGlobalConfig }))
app.mount('#app')
